export default __webpack_public_path__ + "static/media/success.5235ed52.svg";